import { useEffect, useState } from "react";

// Increment this string with every meaningful release.
// When it differs from the user's stored version,
// the banner appears once.
const CURRENT_VERSION = "v10";
const STORAGE_KEY = "caileve_last_seen_version";

// What's new copy — update this with each release.
// Keep it short, in Cailève's voice, one or two sentences.
const WHATS_NEW =
  "Cailève Eye now reads hallmarks, brand signals, and " +
  "price tags in store. Style Me explores more of your " +
  "collection — not just your favorites.";

export function UpdateBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const lastSeen = localStorage.getItem(STORAGE_KEY);
      if (lastSeen !== CURRENT_VERSION) {
        // Small delay so the app is fully loaded before
        // the banner appears — not the first thing seen
        const t = setTimeout(() => setVisible(true), 1800);
        return () => clearTimeout(t);
      }
    } catch {
      // localStorage unavailable — silent
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, CURRENT_VERSION);
    } catch {
      // Silent
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{
        backgroundColor: "#fff",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.08)",
      }}
    >
      {/* Gold accent bar */}
      <div style={{ height: 3, backgroundColor: "var(--caileve-copper)" }} />
      <div className="flex items-start gap-4 px-5 py-4">
        <div className="flex-1">
          <p
            className="text-sm font-semibold"
            style={{ color: "var(--caileve-ink)", fontFamily: "Inter, system-ui, sans-serif" }}
          >
            Cailève has been updated
          </p>
          <p
            className="mt-1 text-sm leading-relaxed"
            style={{ color: "var(--caileve-ink)", fontFamily: "Inter, system-ui, sans-serif" }}
          >
            {WHATS_NEW}
          </p>
        </div>
        <button
          onClick={dismiss}
          aria-label="Dismiss update banner"
          className="text-xl leading-none"
          style={{ color: "var(--caileve-lilac)", padding: "4px" }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
